<template>
    <div class="notice">
        <template v-if="list.length">
            <template v-for="(item, index) in list" :key="index">
                <img class="image height" :src="item.coverUrl || Dynamic" @click.stop="goInformationDetail(item)" v-show="index == active" />
            </template>
            <div class="content">
                <div class="list" @mouseenter.stop="changeImage(index)" @click.stop="goInformationDetail(item)" v-for="(item, index) in list" :key="index">
                    <div class="type" v-if="item.contentType == 'banner'">图片</div>
                    <div class="type" v-else-if="item.contentType == 'notice'">通知</div>
                    <div class="type" v-else-if="item.contentType == 'information'">资讯</div>
                    <div class="type" v-else>动态</div>
                    <div class="text">{{ item.contentTitle }}</div>
                    <div class="time">{{ dayjs(item.publishTime).format('YYYY-MM-DD') }}</div>
                </div>
            </div>
        </template>
        <NoData class="none height" info="抱歉，内容正在更新中，请稍后~" url="no-item.png" v-else />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { goNewsDetail } from '@/lib/tools.js'
import { ArrowRight } from '@element-plus/icons-vue'
import Dynamic from '@/assets/img/project/dynamic.png'
import NoData from '@/components/no-data.vue'
import dayjs from 'dayjs'

defineExpose({ init: getContentByPage })

const emits = defineEmits(['update:bizId', 'changeBizId'])

const props = defineProps({
    pageSize: {
        type: [String, Number],
        default: 5,
    },
    projectType: {
        type: [String, Number],
        default: '',
    },
    categoryCode: {
        type: [String, Number],
        default: '',
    },
    bizId: {
        type: [String, Number],
        default: '',
    },
})

onMounted(init)

async function init() {
    await getContentCategoryList()
    await getContentByPage()
}

const category = ref([])
async function getContentCategoryList() {
    try {
        const queries = { pid: 2 }
        const res = await G_transmit('contentCategoryList', { queries })
        category.value = res?.data || []
    } catch (error) {
        category.value = []
    }
}

const list = ref([])
async function getContentByPage() {
    try {
        const queries = {
            pageSize: props.pageSize,
            pageIndex: 1,
            publishState: 1,
            instAppTypeId: 5,
            publishPlace: 'pc',
            orderType: 'recommend',
            catId1: 2,
            catId2: getBizId(),
        }
        const res = await G_transmit('getContentByPage', { queries })
        list.value = res?.data?.rows || []
    } catch (error) {
        list.value = []
    }
}

const active = ref(0)
function changeImage(index) {
    active.value = index || 0
}

function getBizId() {
    const bizId = category.value?.find?.(item => item?.bizCode == props.projectType)?.id
    emits('update:bizId', bizId)
    emits('changeBizId', bizId)
    return bizId
}

function goInformationDetail(item) {
    goNewsDetail(item, 'informationDetail')
}
</script>

<style lang="scss" scoped>
.notice {
    gap: 16px;
    display: flex;
    .none {
        flex: auto;
    }
    .height {
        height: 216px;
    }
    .image {
        flex: none;
        width: 360px;
        object-fit: cover;
        object-position: center center;
    }
    .content {
        gap: 16px;
        flex: auto;
        display: flex;
        flex-flow: column;
        overflow: hidden;
    }
    .list {
        gap: 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            .text,
            .time {
                color: #1677ff;
            }
        }
    }
    .type {
        flex: none;
        color: #446a8d;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        border: 1px solid #dae1e8;
        border-radius: 4px;
        padding: 0 8px;
    }
    .text {
        flex: auto;
        color: rgba(0, 0, 0, 0.88);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .time {
        flex: none;
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }
}
</style>
